module.exports = __webpack_public_path__ + "img/13_22.ed202154.png";